import './styles.css';
import React from 'react';


function Badge({ className, line1, line2, line3, line4 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 400 400"
      width="100%"
      height="100%"
      className={`BurgerBadge Badge ${className}`}
    >

      {/* ------------------------------------------ */}

      <defs>
        <path id="BurgerBadge__TopCircle" d="M 70 200 A 50 50 0 0 1 330 200" />

        <path
          id="BurgerBadge__BottomCircle"
          d="M 75 200 A 50 50 0 0 0 325 200"
        />
      </defs>

      {/* ------------------------------------------ */}
      {/*
        <rect width="400" height="400" opacity="0" />

        <g>
          <path d="M45.88,31a31.37,31.37,0,0,1,9.25-22A30.75,30.75,0,0,1,76.92,0H323.08a30.93,30.93,0,0,1,31,31V246a154.12,154.12,0,0,1-308.24,0Z"
                className="Badge__FirstFillColor"
          />
          <g className="BURGER">
              <polygon points="128.4 261.73 129.18 259.53 136.94 237.82 152.25 220.46 172.31 207.37 194.15 202.53 212.08 204.52 223.19 206.23 240.26 213.63 250.51 221.6 267.59 243.8 273.57 261.73 128.4 261.73" fill="#f2bf61"/>
              <polygon points="128.4 288.21 192.44 288.21 195 292.48 203.54 299.31 210.38 299.31 215.5 292.48 215.5 286.5 218.92 289.06 273.57 290.77 271.86 299.31 262.47 312.12 249.66 317.24 152.31 317.24 142.06 312.97 135.23 307.85 128.4 299.02 128.4 288.21" fill="#f2bf61"/>
            <polygon points="128.4 271.13 171.95 271.13 173.66 278.81 179.63 282.23 185.61 275.4 188.26 271.13 192.73 271.13 273.57 271.13 269.9 289.06 131.86 289.06 128.4 280.52 128.4 271.13" fill="#7f3419" fillRule="evenodd"/>
            <polygon points="128.4 271.13 171.95 271.13 173.66 278.81 176.22 282.23 183.05 282.23 185.61 275.4 188.26 271.13 192.73 271.13 195 275.4 195 286.5 195 292.48 200.98 298.74 207.56 298.74 215.5 292.48 215.5 279.67 218.35 271.13 233.43 271.13 273.57 271.13 273.57 261.73 128.4 261.73 128.4 271.13" fill="#f7d952"/>
            <g>
              <path d="M200.88,206a70.86,70.86,0,0,0-69,53h138a70.86,70.86,0,0,0-69-53Zm-48.46,11.36A77.13,77.13,0,0,1,276.25,261a1.56,1.56,0,0,1,.16.84,2.93,2.93,0,0,1-2.84,2.84H128.19a.59.59,0,0,1-.5-.17,2.84,2.84,0,0,1-2.18-3.34,77.12,77.12,0,0,1,26.91-43.79Z" fill="#221f20"/>
              <path d="M150.91,286.75a2.76,2.76,0,1,1,0,5.51H131.2a25.49,25.49,0,0,0,7.18,14.87,24.64,24.64,0,0,0,17.55,7.19h89.9a24.64,24.64,0,0,0,17.55-7.19l.17-.16a25,25,0,0,0,7-14.71H250.85a2.76,2.76,0,1,1,0-5.51h22.72a2.81,2.81,0,0,1,2.84,2.84A30.38,30.38,0,0,1,267.56,311l-.17.16A30.42,30.42,0,0,1,245.83,320h-89.9a30.43,30.43,0,0,1-21.56-8.86,30.9,30.9,0,0,1-9-21.55,2.81,2.81,0,0,1,2.84-2.84Z" fill="#221f20"/>
              <path d="M195,286.75a2.76,2.76,0,1,1,0,5.51H137.88a11.26,11.26,0,0,1-9.19-4c-2-2.51-3.18-5.85-3.18-10.36V262a2.79,2.79,0,0,1,2.68-2.84A2.82,2.82,0,0,1,131,262v15.88a10.23,10.23,0,0,0,2,6.68,5.8,5.8,0,0,0,4.85,2.18Z" fill="#221f20"/>
              <path d="M215.92,292.26a2.76,2.76,0,1,1,0-5.51h48a5.8,5.8,0,0,0,4.85-2.18,10.23,10.23,0,0,0,2-6.68V262a2.82,2.82,0,0,1,2.84-2.84,2.93,2.93,0,0,1,2.84,2.84v15.88a16,16,0,0,1-3.34,10.36,11.26,11.26,0,0,1-9.19,4Z" fill="#221f20"/>
              <path d="M273.57,268.53a2.84,2.84,0,1,1,0,5.68H222.1a3.35,3.35,0,0,0-2.34,1,3.07,3.07,0,0,0-1,2.34v11.2a14,14,0,0,1-3.84,9.53l-.17.16a14.18,14.18,0,0,1-9.36,3.68,13.12,13.12,0,0,1-13.2-13.37V276.38a2.09,2.09,0,0,0-.67-1.5,2,2,0,0,0-2.67,0,2,2,0,0,0-.67,1.34,9,9,0,0,1-18.05,0v-2H128.19a2.84,2.84,0,0,1,0-5.68H173a2.82,2.82,0,0,1,2.84,2.84v4.85a3.44,3.44,0,0,0,3.35,3.34,2.81,2.81,0,0,0,2.34-1,3.07,3.07,0,0,0,1-2.34,7.88,7.88,0,0,1,2.34-5.35,7.67,7.67,0,0,1,10.69,0,8.27,8.27,0,0,1,2.34,5.51v12.37a8.16,8.16,0,0,0,2.18,5.52,7.74,7.74,0,0,0,5.34,2.17,7.46,7.46,0,0,0,5.35-2.17h.17a8.2,8.2,0,0,0,2.17-5.52v-11.2a9.62,9.62,0,0,1,2.67-6.35,9.13,9.13,0,0,1,6.35-2.67Z" fill="#221f20"/>
              <path d="M149.74,245.13a2.57,2.57,0,0,1,2.51,2.51,2.43,2.43,0,0,1-2.51,2.34,2.28,2.28,0,0,1-2.33-2.34,2.43,2.43,0,0,1,2.33-2.51Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M172.3,241a4,4,0,1,1-4,4,4.07,4.07,0,0,1,4-4Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M169,224.41a2.43,2.43,0,0,1,2.51,2.34,2.57,2.57,0,0,1-2.51,2.51,2.43,2.43,0,0,1-2.34-2.51,2.29,2.29,0,0,1,2.34-2.34Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M203.55,242.29a4,4,0,1,1-4,4,4.07,4.07,0,0,1,4-4Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M201.55,215.06a4,4,0,1,1-4,4,4.06,4.06,0,0,1,4-4Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M223.27,226.42a2.28,2.28,0,0,1,2.34,2.34,2.42,2.42,0,0,1-2.34,2.5,2.57,2.57,0,0,1-2.5-2.5,2.42,2.42,0,0,1,2.5-2.34Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M253.35,251.15a4,4,0,1,1-4,4,4.06,4.06,0,0,1,4-4Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M225.11,246.3a2.29,2.29,0,0,1,2.34,2.34,2.35,2.35,0,1,1-4.68,0,2.29,2.29,0,0,1,2.34-2.34Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M246.67,228.42a4,4,0,1,1-4,4,4.07,4.07,0,0,1,4-4Z" fill="#1a1a1a" fillRule="evenodd"/>
              <path d="M188.18,235.61a2.57,2.57,0,0,1,2.51,2.51,2.43,2.43,0,0,1-2.51,2.34,2.29,2.29,0,0,1-2.34-2.34,2.43,2.43,0,0,1,2.34-2.51Z" fill="#1a1a1a" fillRule="evenodd"/>
            </g>
          </g>
          <g>
            <path d="M62.72,28.48V246.67a137.38,137.38,0,0,0,274.75,0V28.48a13.3,13.3,0,0,0-3.72-8.81,12.75,12.75,0,0,0-8.8-3.52H75.05a13.13,13.13,0,0,0-8.8,3.52,13.11,13.11,0,0,0-3.53,8.81ZM57.64,246.67V28.48a17.63,17.63,0,0,1,5.08-12.33,18,18,0,0,1,12.33-5.09H325a17.3,17.3,0,0,1,12.33,5.09,17.63,17.63,0,0,1,5.08,12.33V246.67a142.36,142.36,0,0,1-284.72,0Z"
                  className="Badge__SecondFillColor"/>

            <rect x="61.2" y="160" width="278.33" height="5.09"
                  className="Badge__SecondFillColor"/>

          </g>
        </g>
*/}

      {/* ------------------------------------------ */}
      {/*
        <g>
          <circle cx="200" cy="200" r="194.32" className="Badge__FirstFillColor"/>

          <path d="M200,330.24c71.73,0,130.24-58.5,130.24-130.24S271.73,69.76,200,69.76,69.76,128.27,69.76,200,128.27,330.24,200,330.24Z" className="Badge__SecondFillColor" fillRule="evenodd"/>
          <path d="M200.07,72.39A128.17,128.17,0,1,0,328.24,200.56,128.17,128.17,0,0,0,200.07,72.39ZM200,13.78c102.85,0,186.22,83.37,186.22,186.22S302.85,386.22,200,386.22,13.78,302.85,13.78,200,97.16,13.78,200,13.78Z" className="Badge__ThirdFillColor" fillRule="evenodd"/>
          <path d="M200,9.94C305,9.94,390.06,95,390.06,200S305,390.06,200,390.06,9.94,305,9.94,200,95,9.94,200,9.94ZM41.75,77.71Q36,85.14,31,93.1q-1.17,1.84-2.29,3.72l.27,5.76q-1.55,2.72-3,5.47l-5,2.87q-4.17,8.39-7.58,17.2c-.52,1.35-1,2.72-1.52,4.09l1.4,5.61c-.66,2-1.28,4-1.88,6L7,147.57c-.38,1.4-.74,2.82-1.1,4.23-1.49,6-2.72,12.19-3.65,18.43l2.47,5.22c-.25,2.06-.47,4.14-.66,6.22L.48,186.24c-.21,3.11-.36,6.24-.43,9.39l0,2V200c0,3.15.08,6.29.23,9.4l3.44,4.65q.21,3.12.52,6.23l-2.58,5.17q1.2,9.39,3.25,18.51c.32,1.42.66,2.83,1,4.25l4.27,3.88c.55,2,1.13,4,1.74,6l-1.52,5.56c.46,1.38.94,2.76,1.44,4.13Q15,276.67,19,285.15l5,3c.93,1.86,1.89,3.72,2.88,5.55l-.4,5.74c.72,1.26,1.46,2.52,2.21,3.76h0q4.88,8.07,10.47,15.63l5.44,1.94c1.27,1.64,2.57,3.27,3.9,4.87l.73,5.72q1.43,1.65,2.9,3.27c1.06,1.16,2.12,2.3,3.21,3.44l0,0,.78.82,0,0,.18.19,0,0,.18.19,0,0,.18.19,0,0,.18.18,0,0,.18.18,0,0,.18.18,0,0,.18.18,0,0,.18.18,0,0,.18.17,0,0,.18.18,0,0,.39.39,0,0,.18.18,0,0,.18.18c1,1.05,2.11,2.08,3.19,3.11s2.12,2,3.2,3l5.71.86q2.36,2,4.78,4l1.83,5.48Q85.14,364,93.1,369.05h0c1.22.78,2.46,1.54,3.71,2.3l5.77-.28c1.8,1,3.62,2,5.46,3l2.86,5q8.39,4.19,17.21,7.58c1.36.53,2.72,1,4.09,1.53l5.62-1.4c2,.66,3.95,1.28,5.94,1.87l3.8,4.36c1.4.38,2.81.75,4.23,1.1q9.06,2.25,18.43,3.66l5.23-2.48c2,.26,4.12.47,6.2.67l4.58,3.54c3.11.21,6.24.36,9.39.43l2,0H200c3.15,0,6.29-.08,9.4-.23l4.66-3.44c2.08-.15,4.15-.32,6.21-.53l5.17,2.59q9.41-1.2,18.51-3.25c1.42-.32,2.84-.65,4.25-1l3.89-4.28c2-.55,4-1.12,6-1.73l5.57,1.52c1.38-.46,2.75-.94,4.12-1.43q8.89-3.21,17.37-7.21l3-5c1.86-.93,3.72-1.88,5.54-2.88l5.75.4c1.26-.72,2.51-1.46,3.75-2.21h0q8.07-4.87,15.63-10.47l1.95-5.43c1.64-1.28,3.27-2.58,4.87-3.91l5.72-.73c1.1-1,2.19-1.92,3.27-2.9q2.17-2,4.28-4l0,0,.18-.18,0,0,.19-.17,0,0,.19-.18,0,0,.18-.17,0,0,.19-.18,0,0,.19-.18,0,0,.19-.18,0,0,.19-.18,0,0,.18-.18.42-.42,0,0,.18-.17,0,0,.18-.18,0,0,.17-.18.63-.63,0,0,.18-.18,0,0,.79-.81,0,0,.18-.18,0,0,1.22-1.27c1-1.06,2-2.12,3-3.2l.85-5.7c1.37-1.57,2.7-3.17,4-4.79l5.47-1.82q5.75-7.44,10.81-15.4h0c.78-1.22,1.54-2.46,2.29-3.71l-.27-5.76c1-1.8,2-3.63,3-5.47l5-2.86q4.19-8.38,7.59-17.21c.52-1.36,1-2.72,1.52-4.09l-1.4-5.6c.66-2,1.28-4,1.88-6l4.35-3.79c.38-1.4.75-2.81,1.1-4.22q2.25-9.08,3.66-18.44l-2.47-5.22q.38-3.09.66-6.21l3.54-4.58c.21-3.11.36-6.24.43-9.39l0-2.16V200q0-4.73-.23-9.4L396.33,186c-.14-2.08-.31-4.16-.52-6.22l2.58-5.17q-1.2-9.39-3.25-18.51c-.32-1.42-.66-2.84-1-4.25l-4.27-3.89q-.83-3-1.74-6l1.52-5.57c-.46-1.38-.94-2.75-1.43-4.12Q385,123.33,381,114.85l-4.95-3c-.94-1.86-1.89-3.72-2.89-5.55l.4-5.74c-.72-1.26-1.46-2.51-2.21-3.76h0q-4.87-8.08-10.47-15.63l-5.42-1.94c-1.29-1.65-2.59-3.28-3.92-4.88l-.73-5.72q-1.43-1.65-2.9-3.27l-2.4-2.58,0,0-.17-.19,0,0-.2-.22-.18-.19,0,0L344.7,62l0,0-.17-.19,0,0-.17-.19,0,0-.18-.18,0,0-.17-.18,0,0-.18-.19,0,0-.18-.19,0,0-.18-.18,0,0-.18-.18,0,0-.18-.18,0,0-.17-.19,0,0-.18-.19,0,0-.18-.17,0,0-.18-.17-.21-.21,0,0-.18-.18,0,0-.19-.18,0,0-.39-.39,0,0-.18-.18-.21-.21,0,0c-.9-.9-1.82-1.79-2.74-2.67s-2.12-2-3.2-3l-5.7-.86q-2.36-2-4.79-4l-1.83-5.49Q314.88,36,306.91,31h0c-1.23-.78-2.47-1.54-3.71-2.29l-5.77.27c-1.8-1-3.63-2-5.47-3l-2.87-5q-8.37-4.17-17.2-7.58c-1.35-.52-2.72-1-4.09-1.52l-5.61,1.4c-2-.66-4-1.28-5.95-1.87L252.43,7c-1.4-.39-2.81-.75-4.23-1.1q-9.06-2.25-18.43-3.66l-5.23,2.48c-2-.26-4.12-.47-6.2-.67L213.76.48c-3.11-.21-6.24-.36-9.39-.43l-2,0H200q-4.73,0-9.4.23l-4.66,3.44c-2.08.15-4.15.32-6.21.53l-5.18-2.6q-9.39,1.2-18.5,3.26c-1.43.32-2.84.66-4.25,1l-3.9,4.28c-2,.55-4,1.12-6,1.73l-5.57-1.52c-1.38.47-2.76.94-4.13,1.44Q123.33,15,114.85,19l-3,5q-2.79,1.39-5.54,2.88l-5.75-.4c-1.27.72-2.52,1.46-3.77,2.22h0Q88.75,33.53,81.2,39.12l-2,5.44q-2.46,1.9-4.86,3.9l-5.74.73Q67,50.63,65.39,52.1L62.8,54.49l0,0-.43.4-.19.18,0,0-.82.78,0,0-.19.18,0,0-.19.18,0,0-.19.17,0,0-.18.18,0,0-.18.17,0,0-.18.18,0,0-.18.19,0,0-.18.18,0,0-.19.17,0,0-.18.18-.62.63,0,0-.18.19,0,0c-1.1,1.11-2.2,2.23-3.28,3.37s-2,2.12-3,3.2l-.85,5.7c-1.37,1.57-2.7,3.17-4,4.79Z" className="Badge__ThirdFillColor" fillRule="evenodd"/>
          <path d="M102.26,324.12A157.7,157.7,0,0,1,42,200a160.55,160.55,0,0,1,1.22-19.73c.51.17,1,.34,1.54.49a27.29,27.29,0,0,0,3.34.71A155.34,155.34,0,0,0,47,200a152.73,152.73,0,0,0,57.79,119.77l-2.32,4c-.08.13-.16.26-.23.39ZM356.68,179.67A160.46,160.46,0,0,1,358,200a157.71,157.71,0,0,1-63.34,126.5l-1-5.53A153.11,153.11,0,0,0,351.82,181Z" className="Badge__FirstFillColor" fillRule="evenodd"/>
        </g>



        <g>
          <path d="M236.51,165.66l36.72-36.72-1.48-1.47L235,164.19C235.53,164.67,236,165.16,236.51,165.66Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M242.23,172.76,285,143.49l-1.17-1.72L241,171.05C241.45,171.61,241.85,172.18,242.23,172.76Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M285.94,190.19l-35.89,3.57c.09.68.16,1.37.22,2.07l35.88-3.57Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M246.81,181.4l47.67-20.22-.81-1.92L246,179.49C246.26,180.12,246.54,180.75,246.81,181.4Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M267.54,252.82,240.1,230.35c-.42.55-.86,1.09-1.31,1.62l27.43,22.46Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M282.71,223.65l-34-10.43c-.19.67-.38,1.33-.59,2l34,10.44Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M285.77,207.83,250.3,204c-.06.69-.12,1.39-.21,2.07l35.45,3.85Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M277,238l-31.51-16.38c-.3.63-.62,1.25-.95,1.86l31.5,16.37Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M212.12,151.89,222.83,101l-2-.43-10.71,50.93Q211.12,151.65,212.12,151.89Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M228.73,159.12l28.41-43.52-1.75-1.14L227,158C227.57,158.35,228.16,158.73,228.73,159.12Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M200.43,150.62l.73,0V98.92h-2.32v51.74C200,150.64,199.94,150.62,200.43,150.62Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M207.34,151l3.89-35.89-2.07-.23-3.89,35.9C206,150.87,206.65,151,207.34,151Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M197.2,150.78l-3.61-36.24-2.07.21,3.6,36.23C195.81,150.9,196.5,150.84,197.2,150.78Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M222.72,155.64c.63.3,1.25.62,1.86,1l16.61-32-1.85-1Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M220.94,154.81l20.1-48-1.93-.8L219,154C219.66,154.27,220.31,154.53,220.94,154.81Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M216.4,153.08,227,118.59l-2-.61L214.4,152.47C215.08,152.66,215.74,152.86,216.4,153.08Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M134.49,146.54l27.81,22.78c.43-.55.88-1.08,1.33-1.61l-27.82-22.79Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M265.53,144.11,238,167.25c.46.52.91,1,1.35,1.58l27.53-23.12Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M145.44,135.17l23.17,27.56c.52-.45,1.06-.9,1.6-1.33L147,133.83Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M254.16,133.15,231.33,161c.55.43,1.09.86,1.62,1.31l22.82-27.86Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M249.53,190.46l50.59-10.72-.44-2-50.61,10.73C249.24,189.1,249.39,189.78,249.53,190.46Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M281.83,172.88l-34.14,10.86c.23.65.45,1.31.65,2l34.12-10.85Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M275.23,157.94l-31.51,17.21c.35.6.69,1.21,1,1.82l31.49-17.2Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M126.8,241.42l31.16-17c-.35-.6-.67-1.21-1-1.83l-31.17,17Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M120.19,226.48l33.9-10.78c-.22-.66-.42-1.33-.61-2l-33.92,10.79Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M256.58,264.19,233.8,237.08c-.52.46-1,.92-1.58,1.35L255,265.53Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M125,161.35l31.84,16.54c.31-.62.63-1.24,1-1.84L125.94,159.5Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M147.87,266.2l22.43-27.38c-.55-.43-1.08-.88-1.61-1.33l-22.43,27.39Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M116.08,209.17l35.8-3.56c-.08-.69-.14-1.38-.19-2.08l-35.81,3.57Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M119.31,175.7l34.24,10.51c.19-.67.4-1.33.62-2l-34.25-10.51Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M116.26,191.53l35.53,3.86c.06-.7.15-1.39.24-2.07l-35.55-3.86Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M136.5,255.25l27.14-22.81c-.46-.52-.9-1.06-1.33-1.6l-27.15,22.81Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M200.43,249.53c-.49,0-.43,0-1.59,0v51.59h2.32V249.51Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M210.32,248.64,221,298.78l2-.43-10.63-50.14C211.69,248.36,211,248.51,210.32,248.64Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M219.49,245.94l20,47.21,1.92-.81-20-47.22C220.78,245.41,220.14,245.68,219.49,245.94Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M215.12,247.47l10.7,33.66,2-.63L217.1,246.84C216.45,247.06,215.79,247.28,215.12,247.47Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M204.91,249.36l3.52,35.45,2.07-.2L207,249.16C206.29,249.24,205.6,249.31,204.91,249.36Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M194.6,249.1l-3.81,35.11,2.08.22,3.8-35.1C196,249.27,195.29,249.19,194.6,249.1Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M185.41,247l-10.36,33.77,2,.61,10.36-33.77C186.73,247.42,186.06,247.22,185.41,247Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M189.74,248.22,179.2,298.38l2,.43,10.54-50.16C191.1,248.53,190.42,248.38,189.74,248.22Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M235.43,235.57l36.32,36.32,1.48-1.47-36.34-36.33C236.42,234.59,235.93,235.09,235.43,235.57Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M249.27,210.89l50.45,10.6.43-2-50.47-10.61C249.55,209.53,249.42,210.21,249.27,210.89Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M250.44,198.84s0,.86,0,1.24,0,1.08,0,1.08h50.64v-2.32Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M246.36,219.81l47.48,19.89.8-1.92-47.49-19.9C246.9,218.53,246.64,219.17,246.36,219.81Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M180.81,245.21,161,292.5l1.92.81L182.73,246Q181.76,245.63,180.81,245.21Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M228.24,241.35l29,42.36,1.72-1.18-29-42.37C229.39,240.57,228.82,241,228.24,241.35Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M224,243.87l16.95,31,1.83-1-16.95-31C225.2,243.21,224.59,243.55,224,243.87Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M242,227.7l43,28.1,1.14-1.74L243.16,226C242.8,226.54,242.43,227.13,242,227.7Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M156,179.68l-47.78-20-.81,1.93,47.76,20C155.41,180.94,155.68,180.31,156,179.68Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M167,164.19l-36.73-36.72-1.47,1.47,36.72,36.72C166,165.16,166.5,164.67,167,164.19Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M174.16,158.56l-29.34-42.91-1.72,1.17,29.33,42.91C173,159.33,173.58,158.93,174.16,158.56Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M160.37,171.91l-43.43-28.35-1.14,1.74,43.42,28.35C159.6,173.06,160,172.48,160.37,171.91Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M179,244.35c-.62-.31-1.24-.63-1.85-1l-16.29,31.37,1.84,1Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M191.87,151.48l-10.79-50.9-2,.43,10.78,50.9C190.5,151.75,191.18,151.61,191.87,151.48Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M182.82,154.09l-20.3-47.88-1.92.81,20.3,47.88Q181.85,154.48,182.82,154.09Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M178.39,156.1,161.1,124.47l-1.83,1,17.29,31.63C177.16,156.75,177.77,156.42,178.39,156.1Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M187.14,152.61,176.2,118.23l-2,.63,10.93,34.38C185.81,153,186.47,152.8,187.14,152.61Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M165.13,234.09,128.8,270.42l1.47,1.47,36.33-36.32C166.1,235.09,165.61,234.59,165.13,234.09Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M152.93,188.51l-50.62-10.64-.43,2,50.61,10.63C152.62,189.86,152.77,189.18,152.93,188.51Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M172.94,240.78l-28.05,43,1.75,1.14,28-43C174.09,241.56,173.51,241.18,172.94,240.78Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M159.44,226.84l-42.46,29,1.18,1.72,42.44-29C160.2,228,159.82,227.43,159.44,226.84Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M151.56,200.08c0-.38,0-1.24,0-1.24H98.92v2.32h52.66S151.56,200.4,151.56,200.08Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M152.36,208.92l-50.45,10.69.43,2L152.78,211C152.62,210.29,152.49,209.61,152.36,208.92Z" className="Badge__FirstFillColor" opacity="0.1"/>
          <path d="M155,218.07l-47.41,20.1.82,1.92L155.75,220C155.47,219.36,155.21,218.72,155,218.07Z" className="Badge__FirstFillColor" opacity="0.1"/>
        </g>






      <g id="_Gruppe_" data-name="&lt;Gruppe&gt;">
        <g id="_Gruppe_2" data-name="&lt;Gruppe&gt;">
          <g id="_Gruppe_3" data-name="&lt;Gruppe&gt;">
            <rect id="_Rechteck_" data-name="&lt;Rechteck&gt;" x="187.61" y="226.55" width="22.8" height="6.14" fill="#fcd669"/>
          </g>
          <g id="_Gruppe_4" data-name="&lt;Gruppe&gt;">
            <g id="_Gruppe_5" data-name="&lt;Gruppe&gt;">
              <g id="_Gruppe_6" data-name="&lt;Gruppe&gt;">
                <path id="_Pfad_" data-name="&lt;Pfad&gt;" d="M140.92,232.7H259.08a4.54,4.54,0,0,1,4.54,4.54l-2,6.51c0,7-6.67,13.67-13.67,13.67h-94.9c-7,0-15.67-6.67-15.67-13.67l-1-6.51A4.54,4.54,0,0,1,140.92,232.7Z" fill="#f6b13a"/>
              </g>
              <g id="_Gruppe_7" data-name="&lt;Gruppe&gt;">
                <path id="_Pfad_2" data-name="&lt;Pfad&gt;" d="M257.1,232.7H246.58c.49,4.49-.15,12.87-11,15.54-15.1,3.72-81.34,5.25-96.41.65h0a18.19,18.19,0,0,0,15.42,8.53h90.84a18.2,18.2,0,0,0,18.2-18.2h0A6.52,6.52,0,0,0,257.1,232.7Z" fill="#f7952c"/>
              </g>
            </g>
            <g id="_Gruppe_8" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_3" data-name="&lt;Pfad&gt;" d="M156,242.57h-6.76a1.63,1.63,0,0,0,0,3.25H156A1.63,1.63,0,0,0,156,242.57Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_9" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_4" data-name="&lt;Pfad&gt;" d="M202.7,238.06h-3.9a1.63,1.63,0,0,0,0,3.25h3.9A1.63,1.63,0,0,0,202.7,238.06Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_10" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_5" data-name="&lt;Pfad&gt;" d="M242.43,246.87h-10a1.63,1.63,0,0,0,0,3.25h10A1.63,1.63,0,0,0,242.43,246.87Z" fill="#fcd669"/>
            </g>
          </g>
          <g id="_Gruppe_11" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_6" data-name="&lt;Pfad&gt;" d="M255.71,198.82H144.29a6.31,6.31,0,0,1-6.29-6.29h0a6.32,6.32,0,0,1,6.29-6.3H255.71a6.32,6.32,0,0,1,6.29,6.3h0A6.31,6.31,0,0,1,255.71,198.82Z" fill="#bc5f46"/>
          </g>
          <g id="_Gruppe_12" data-name="&lt;Gruppe&gt;">
            <rect id="_Pfad_7" data-name="&lt;Pfad&gt;" x="134.34" y="202.55" width="131.33" height="17.07" rx="8.42" ry="8.42" fill="#f05755"/>
          </g>
          <g id="_Gruppe_13" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_8" data-name="&lt;Pfad&gt;" d="M257.24,202.55H230.75a12.12,12.12,0,0,1-2.64.65L223.27,212h0a2.16,2.16,0,0,1-.65,4.21c-31.25.49-87-1.14-87.35-1.15a8.43,8.43,0,0,0,7.49,4.59H257.24a6.85,6.85,0,0,0,.79,0h.11c.22,0,.44-.06.65-.1l.24,0,.53-.14.35-.11.07,0a8.45,8.45,0,0,0,5.68-8V211A8.44,8.44,0,0,0,257.24,202.55Z" fill="#e24647"/>
          </g>
          <g id="_Gruppe_14" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_9" data-name="&lt;Pfad&gt;" d="M262,192.53a6.32,6.32,0,0,0-6.29-6.3H248.2c1.49,1.44,3.07,3.67,2.38,6.3-1.13,4.28-90.64,4.49-112.51.88a6.31,6.31,0,0,0,6.22,5.41H255.71A6.31,6.31,0,0,0,262,192.53Z" fill="#aa3c26"/>
          </g>
          <g id="_Gruppe_15" data-name="&lt;Gruppe&gt;">
            <g id="_Gruppe_16" data-name="&lt;Gruppe&gt;">
              <g id="_Gruppe_17" data-name="&lt;Gruppe&gt;">
                <g id="_Gruppe_18" data-name="&lt;Gruppe&gt;">
                  <path id="_Pfad_10" data-name="&lt;Pfad&gt;" d="M195.5,232.7H143.58a5.59,5.59,0,0,1-5.57-5.58h0a5.59,5.59,0,0,1,5.57-5.57H195.5a5.59,5.59,0,0,1,5.58,5.57h0A5.6,5.6,0,0,1,195.5,232.7Z" fill="#bc5f46"/>
                </g>
              </g>
              <g id="_Gruppe_19" data-name="&lt;Gruppe&gt;">
                <path id="_Pfad_11" data-name="&lt;Pfad&gt;" d="M195.5,221.55h-1.3c.52,1.66.45,4.76-6,6.78-9.15,2.86-43.37,1.36-49.4,0a5.59,5.59,0,0,0-.68-.12,5.59,5.59,0,0,0,5.46,4.49H195.5a5.6,5.6,0,0,0,5.58-5.58h0A5.59,5.59,0,0,0,195.5,221.55Z" fill="#aa3c26"/>
              </g>
              <g id="_Gruppe_20" data-name="&lt;Gruppe&gt;">
                <g id="_Gruppe_21" data-name="&lt;Gruppe&gt;">
                  <path id="_Zusammengesetzter_Pfad_" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M195.5,234.13H143.58a7,7,0,0,1,0-14H195.5a7,7,0,0,1,0,14ZM143.58,223a4.14,4.14,0,0,0,0,8.28H195.5a4.14,4.14,0,0,0,0-8.28Z" fill="#84171a"/>
                </g>
              </g>
            </g>
            <g id="_Gruppe_22" data-name="&lt;Gruppe&gt;">
              <g id="_Gruppe_23" data-name="&lt;Gruppe&gt;">
                <g id="_Gruppe_24" data-name="&lt;Gruppe&gt;">
                  <path id="_Pfad_12" data-name="&lt;Pfad&gt;" d="M256.42,232.7H204.5a5.6,5.6,0,0,1-5.58-5.58h0a5.59,5.59,0,0,1,5.58-5.57h51.92a5.59,5.59,0,0,1,5.57,5.57h0A5.59,5.59,0,0,1,256.42,232.7Z" fill="#bc5f46"/>
                </g>
              </g>
              <g id="_Gruppe_25" data-name="&lt;Gruppe&gt;">
                <path id="_Pfad_13" data-name="&lt;Pfad&gt;" d="M256.42,221.55h-1.3c.51,1.66.44,4.76-6,6.78-9.15,2.86-43.38,1.36-49.41,0a5.59,5.59,0,0,0-.68-.12,5.61,5.61,0,0,0,5.47,4.49h51.92a5.59,5.59,0,0,0,5.57-5.58h0A5.59,5.59,0,0,0,256.42,221.55Z" fill="#aa3c26"/>
              </g>
            </g>
          </g>
          <g id="_Gruppe_26" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_14" data-name="&lt;Pfad&gt;" d="M140.42,186.5a2.75,2.75,0,0,1,3-2.44H256.6a2.49,2.49,0,1,1,0,4.88s-14.09,1.12-16.75,3.3-2.78,3.66-7.13,2.17-5.32-3.95-10.28-3-4,2.37-10.87,1.28-15-4.06-22-1.19-5.44,6.93-13.42,5.05-10.28-6.83-15.72-5.74-11.24,1.29-14,.3a19.41,19.41,0,0,1-4.83-2.72A2.31,2.31,0,0,1,140.42,186.5Z" fill="#9db73e"/>
          </g>
          <g id="_Gruppe_27" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_15" data-name="&lt;Pfad&gt;" d="M256.6,188.94a2.49,2.49,0,1,0,0-4.88H244.53c-1.08,1.9-3.53,5.14-7.77,5.34-6,.27-11.63-2.32-21,0-3.94,1-6.76,1.79-9.1,2.37,1.69.36,3.34.71,4.94,1,6.89,1.09,5.92-.29,10.87-1.28s5.93,1.48,10.28,3,4.47,0,7.13-2.17S256.6,188.94,256.6,188.94Z" fill="#8da43c"/>
          </g>
          <g id="_Gruppe_28" data-name="&lt;Gruppe&gt;">
            <path id="_Zusammengesetzter_Pfad_2" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M179.58,198.5a16.73,16.73,0,0,1-3.76-.51,28.27,28.27,0,0,1-8.53-3.74c-2.49-1.5-4.13-2.48-6.57-2-4.93,1-11.41,1.44-14.79.24a20.93,20.93,0,0,1-5.17-2.89A3.74,3.74,0,0,1,139,186.5a4.17,4.17,0,0,1,4.42-3.87H256.6a3.91,3.91,0,1,1,.06,7.75c-5.66.45-14.31,1.67-15.9,3-.48.39-.87.76-1.25,1.12-1.82,1.72-3.15,2.7-7.25,1.3a21,21,0,0,1-3.77-1.77c-1.87-1.06-3-1.7-5.76-1.15a19.68,19.68,0,0,0-3.21.93c-2.07.76-3.38,1.13-8.18.37-1.58-.25-3.18-.59-4.87-1-5.57-1.17-11.33-2.39-16.36-.33a15.58,15.58,0,0,0-4.85,3.13C183.58,197.48,182.18,198.5,179.58,198.5Zm-17.65-9.24c2.63,0,4.69,1.24,6.83,2.53a25.72,25.72,0,0,0,7.72,3.41c4.23,1,5.06.26,6.88-1.34a18.11,18.11,0,0,1,5.66-3.64c5.85-2.39,12.32-1,18,.18,1.65.35,3.22.68,4.73.92,4.28.67,5.15.35,6.74-.23a22.07,22.07,0,0,1,3.63-1.05,9.66,9.66,0,0,1,7.74,1.46,18.31,18.31,0,0,0,3.28,1.56c2.68.91,3,.64,4.36-.68.39-.37.84-.79,1.4-1.25,2.86-2.34,15.12-3.42,17.55-3.62h.11c.91,0,1.55-.53,1.55-1s-.64-1-1.55-1H143.4c-.91,0-1.55.53-1.55,1a1,1,0,0,0,.5.72l.1.07a18.23,18.23,0,0,0,4.44,2.51c2.44.87,7.89.72,13.26-.35A8.78,8.78,0,0,1,161.93,189.26Z" fill="#84171a"/>
          </g>
          <g id="_Gruppe_29" data-name="&lt;Gruppe&gt;">
            <path id="_Zusammengesetzter_Pfad_3" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M245.42,258.86H154.58a19.66,19.66,0,0,1-19.64-19.64,8,8,0,0,1,8-8H257.09a8,8,0,0,1,8,8A19.66,19.66,0,0,1,245.42,258.86ZM142.91,234.13a5.1,5.1,0,0,0-5.1,5.09A16.79,16.79,0,0,0,154.58,256h90.84a16.79,16.79,0,0,0,16.77-16.77,5.1,5.1,0,0,0-5.1-5.09Z" fill="#84171a"/>
          </g>
          <g id="_Gruppe_30" data-name="&lt;Gruppe&gt;">
            <g id="_Gruppe_31" data-name="&lt;Gruppe&gt;">
              <g id="_Gruppe_32" data-name="&lt;Gruppe&gt;">
                <path id="_Pfad_16" data-name="&lt;Pfad&gt;" d="M142.07,186.23a6.3,6.3,0,0,1-6.11-7.32c4.16-27.27,31.25-48.33,64-48.33s59.88,21.06,64,48.33a6.3,6.3,0,0,1-6.11,7.32Z" fill="#f6b13a"/>
              </g>
              <g id="_Gruppe_33" data-name="&lt;Gruppe&gt;">
                <path id="_Pfad_17" data-name="&lt;Pfad&gt;" d="M264,178.91c-3.46-22.68-22.77-41.06-48-46.61,0,0,23.59,14.75,16.57,38-6.17,20.39-79,11.05-96.58,8.48l0,.17a6.3,6.3,0,0,0,6.11,7.32H257.93A6.3,6.3,0,0,0,264,178.91Z" fill="#f7952c"/>
              </g>
            </g>
            <g id="_Gruppe_34" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_18" data-name="&lt;Pfad&gt;" d="M161.53,155.56h-4.71a1.63,1.63,0,0,0,0,3.25h4.71A1.63,1.63,0,0,0,161.53,155.56Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_35" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_19" data-name="&lt;Pfad&gt;" d="M187.13,145.12h-9.42a1.63,1.63,0,0,0,0,3.25h9.42A1.63,1.63,0,0,0,187.13,145.12Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_36" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_20" data-name="&lt;Pfad&gt;" d="M207.61,155.77h-4.1a1.63,1.63,0,0,0,0,3.25h4.1A1.63,1.63,0,0,0,207.61,155.77Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_37" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_21" data-name="&lt;Pfad&gt;" d="M163.58,173h-5.73a1.63,1.63,0,0,0,0,3.25h5.73A1.63,1.63,0,0,0,163.58,173Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_38" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_22" data-name="&lt;Pfad&gt;" d="M215.6,169.08h-2a1.64,1.64,0,0,0-1.63,1.62,1.66,1.66,0,0,0,1.63,1.63h2a1.63,1.63,0,0,0,0-3.25Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_39" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_23" data-name="&lt;Pfad&gt;" d="M236.49,147.57H225.84a1.63,1.63,0,0,0,0,3.25h10.65A1.63,1.63,0,0,0,236.49,147.57Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_40" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_24" data-name="&lt;Pfad&gt;" d="M247.75,175.43h-5.12a1.63,1.63,0,0,0,0,3.25h5.12A1.63,1.63,0,0,0,247.75,175.43Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_41" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_25" data-name="&lt;Pfad&gt;" d="M184.88,167.44h-2.46a1.63,1.63,0,1,0,0,3.25h2.46a1.63,1.63,0,0,0,0-3.25Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_42" data-name="&lt;Gruppe&gt;">
              <path id="_Pfad_26" data-name="&lt;Pfad&gt;" d="M208.43,136.31h-3.69a1.63,1.63,0,0,0,0,3.25h3.69A1.63,1.63,0,0,0,208.43,136.31Z" fill="#fcd669"/>
            </g>
            <g id="_Gruppe_43" data-name="&lt;Gruppe&gt;">
              <path id="_Zusammengesetzter_Pfad_4" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M257.93,187.67H142.07a7.54,7.54,0,0,1-5.72-2.66,7.84,7.84,0,0,1-1.81-6.31c2.08-13.64,9.84-26.19,21.83-35.32a74,74,0,0,1,87.26,0c12,9.13,19.75,21.68,21.83,35.32a7.84,7.84,0,0,1-1.81,6.31A7.54,7.54,0,0,1,257.93,187.67ZM200,132c-31.6,0-58.53,20.26-62.62,47.12a5,5,0,0,0,1.14,4,4.7,4.7,0,0,0,3.55,1.65H257.93a4.69,4.69,0,0,0,3.55-1.65,5,5,0,0,0,1.14-4C258.53,152.27,231.6,132,200,132Z" fill="#84171a"/>
            </g>
          </g>
          <g id="_Gruppe_44" data-name="&lt;Gruppe&gt;">
            <path id="_Zusammengesetzter_Pfad_5" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M255.71,200.25H144.29a7.73,7.73,0,0,1,0-15.45H255.71a7.73,7.73,0,0,1,0,15.45ZM144.29,187.67a4.86,4.86,0,1,0,0,9.71H255.71a4.86,4.86,0,1,0,0-9.71Z" fill="#84171a"/>
          </g>
          <g id="_Gruppe_45" data-name="&lt;Gruppe&gt;">
            <path id="_Zusammengesetzter_Pfad_6" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M257.24,221.06H142.76a9.87,9.87,0,0,1-9.86-9.86V211a9.86,9.86,0,0,1,9.86-9.85H257.24A9.86,9.86,0,0,1,267.1,211v.23A9.87,9.87,0,0,1,257.24,221.06ZM142.76,204a7,7,0,0,0-7,7v.23a7,7,0,0,0,7,7H257.24a7,7,0,0,0,7-7V211a7,7,0,0,0-7-7Z" fill="#84171a"/>
          </g>
          <g id="_Gruppe_46" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_27" data-name="&lt;Pfad&gt;" d="M259.43,221.63a3.2,3.2,0,0,0-2.86-2H143.44a3,3,0,0,0-2.88,2c-.63,2.05,3,3.93,5,3.93,0,0,10.51,1.11,13.17,3.77s4.76,5.71,9.11,3.9,4.79-5.82,9.75-4.61,4,2.9,10.87,1.57,15-5,22-1.45,5.44,8.46,13.42,6.16,10.28-8.34,15.72-7,11.24,1.57,14,.36a19,19,0,0,0,4.83-3.31A3,3,0,0,0,259.43,221.63Z" fill="#9db73e"/>
          </g>
          <g id="_Gruppe_47" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_28" data-name="&lt;Pfad&gt;" d="M256.57,219.62H244c-1.75,2.44-6,5.77-15.83,5.68-15.57-.13-24.85-3.93-36.46,2.27a52,52,0,0,1-7,3.13,24.24,24.24,0,0,0,3.73-.48c6.89-1.33,15-5,22-1.45s5.44,8.46,13.42,6.16,10.28-8.34,15.72-7,11.24,1.57,14,.36a19,19,0,0,0,4.83-3.31,3,3,0,0,0,1-3.34A3.2,3.2,0,0,0,256.57,219.62Z" fill="#8da43c"/>
          </g>
          <g id="_Gruppe_48" data-name="&lt;Gruppe&gt;">
            <path id="_Zusammengesetzter_Pfad_7" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M220.39,237c-2.64,0-4.06-1.26-5.75-3.08a15.43,15.43,0,0,0-4.85-3.83c-4.95-2.48-10.67-1-16.2.42-1.69.44-3.29.85-4.88,1.15-4.87.94-6.27.47-8.32-.46a16.77,16.77,0,0,0-3.17-1.12c-2.31-.56-3.16.22-4.69,1.64a13.62,13.62,0,0,1-4.17,2.9c-4.74,2-7.41-.81-9.77-3.27l-.91-.93c-1.66-1.67-8.35-2.94-12.23-3.36a8.18,8.18,0,0,1-5.67-2.82,3.3,3.3,0,0,1-.59-3,4.44,4.44,0,0,1,4.25-3.05H256.57a4.6,4.6,0,0,1,4.22,3h0a4.41,4.41,0,0,1-1.45,4.86,20.23,20.23,0,0,1-5.18,3.54c-3,1.31-8.87,1.2-14.93-.29-2.24-.54-3.74.45-6.41,2.41a26,26,0,0,1-8.57,4.59A14.39,14.39,0,0,1,220.39,237ZM203.7,225.85a16.28,16.28,0,0,1,7.38,1.63,18.32,18.32,0,0,1,5.66,4.45c1.85,2,2.61,2.81,6.72,1.62a23.33,23.33,0,0,0,7.67-4.14c2.64-1.94,5.13-3.77,8.78-2.88,5.23,1.28,10.75,1.46,13.11.44a17.79,17.79,0,0,0,4.43-3.06l.09-.08a1.56,1.56,0,0,0,.52-1.76h0a1.78,1.78,0,0,0-1.49-1H143.44a1.55,1.55,0,0,0-1.51,1c0,.11.07.28.16.41a5.43,5.43,0,0,0,3.44,1.65h.15c1.13.12,11.1,1.26,14,4.19l.95,1c2.41,2.52,3.8,3.78,6.6,2.61a10.9,10.9,0,0,0,3.32-2.35c1.64-1.53,3.51-3.26,7.32-2.33a19.8,19.8,0,0,1,3.67,1.3c1.59.71,2.38,1.07,6.59.26,1.51-.29,3.07-.69,4.72-1.12A44.32,44.32,0,0,1,203.7,225.85Z" fill="#84171a"/>
          </g>
          <g id="_Gruppe_49" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_29" data-name="&lt;Pfad&gt;" d="M259.33,198.82H141.56a1.87,1.87,0,1,0,0,3.73h45.07s26.42,6.7,38.81,10a8.35,8.35,0,0,0,5.55-.46l21.16-9.54h7.18a1.87,1.87,0,0,0,0-3.73Z" fill="#fcd669"/>
          </g>
          <g id="_Gruppe_50" data-name="&lt;Gruppe&gt;">
            <path id="_Pfad_30" data-name="&lt;Pfad&gt;" d="M259.33,198.82h-22.2c-.7,3.17-3.09,9.62-11.09,10.26-10.65.84-22.87-2.31-22.87-2.31h0c7.75,2,16.52,4.25,22.27,5.78a8.35,8.35,0,0,0,5.55-.46l21.16-9.54h7.18a1.87,1.87,0,0,0,0-3.73Z" fill="#fbc231"/>
          </g>
          <g id="_Gruppe_51" data-name="&lt;Gruppe&gt;">
            <path id="_Zusammengesetzter_Pfad_8" data-name="&lt;Zusammengesetzter Pfad&gt;" d="M227.57,214.25a9.5,9.5,0,0,1-2.49-.32c-11.73-3.11-36.32-9.36-38.63-9.94H141.56a3.31,3.31,0,1,1,0-6.61H259.33a3.31,3.31,0,0,1,0,6.61h-6.87l-20.88,9.41A9.79,9.79,0,0,1,227.57,214.25Zm-86-14a.44.44,0,0,0-.44.43.44.44,0,0,0,.44.44h45.25l.17,0c.27.07,26.57,6.74,38.83,10a6.91,6.91,0,0,0,4.59-.38l21.44-9.66h7.49a.44.44,0,0,0,.43-.44.43.43,0,0,0-.43-.43Z" fill="#84171a"/>
          </g>
        </g>
      </g>

*/}

      {/* ------------------------------------------ */}

      <g>

        <g>
          <path
            d="M392.16,238.72a19.55,19.55,0,0,1-6.37,23.82l-12.68,9.16-14.66,10.59a19.63,19.63,0,0,0-8,13.83l-1.83,18-1.6,15.49a19.59,19.59,0,0,1-17.44,17.48l-15.53,1.6-12.29,1.25-5.67.61a19.53,19.53,0,0,0-13.83,7.94l-10.6,14.66-9.15,12.68a19.58,19.58,0,0,1-23.82,6.37l-14.28-6.4-3.36-1.51L208,378.39a19.49,19.49,0,0,0-8-1.72,19.26,19.26,0,0,0-8,1.72l-16.45,7.37-14.31,6.4a19.6,19.6,0,0,1-23.85-6.37l-9.12-12.68-10.57-14.63a19.72,19.72,0,0,0-13.83-8l-18-1.86L70.39,347a19.59,19.59,0,0,1-11.81-5.6A19.85,19.85,0,0,1,53,329.61l-1.6-15.53-1.83-18a19.68,19.68,0,0,0-8-13.83l-14.6-10.53-12.71-9.19a19.55,19.55,0,0,1-6.37-23.82l6.4-14.28L21.64,208a19.6,19.6,0,0,0,0-16L15.75,179l-1.51-3.36-6.4-14.31a19.53,19.53,0,0,1,6.44-23.82l12.64-9.15,14.63-10.57a19.41,19.41,0,0,0,8-13.83l.61-5.69L51.38,86,53,70.4A19.57,19.57,0,0,1,70.43,53L86,51.38l17.93-1.82a19.56,19.56,0,0,0,13.86-8l10.57-14.63,9.15-12.67a19.57,19.57,0,0,1,23.82-6.41l14.25,6.41L192,21.64a20,20,0,0,0,8,1.7,19.72,19.72,0,0,0,8-1.7l16.48-7.39,14.25-6.41a19.56,19.56,0,0,1,23.82,6.37l9.15,12.71,10.57,14.6a19.55,19.55,0,0,0,13.86,8l18,1.86L329.61,53a19.52,19.52,0,0,1,17.44,17.41l1.6,15.6,1.83,17.92a19.67,19.67,0,0,0,8,13.86l14.63,10.57,12.68,9.15a19.55,19.55,0,0,1,6.37,23.82l-6.4,14.28-7.37,16.49a19.34,19.34,0,0,0,0,16l7.37,16.46Z"
            className="Badge__SecondFillColor"
          />
          <path
            d="M395.63,212.34l-9.89,12.14L378,234l-3.58,4.45a19.49,19.49,0,0,0-4.16,15.39l2.88,17.84,2.49,15.46a19.58,19.58,0,0,1-12.35,21.35l-14.6,5.57-3.46,1.31-13.38,5.09a19.49,19.49,0,0,0-11.3,11.3l-6.44,16.87-5.57,14.6a19.55,19.55,0,0,1-21.35,12.36l-15.46-2.5-17.8-2.88a19.67,19.67,0,0,0-15.43,4.13l-14,11.4-12.1,9.86a19.53,19.53,0,0,1-24.65,0l-12.1-9.86-14-11.4a19.74,19.74,0,0,0-15.46-4.13l-17.8,2.88-15.43,2.5a19.55,19.55,0,0,1-21.35-12.36l-5.57-14.63L79.5,331.78a19.41,19.41,0,0,0-11.3-11.3l-13.38-5.09-3.49-1.31-14.59-5.57a19.56,19.56,0,0,1-12.3-21.38l2.47-15.4,2.88-17.87a19.41,19.41,0,0,0-4.16-15.39L22,234l-7.81-9.58-9.86-12.1a19.6,19.6,0,0,1,0-24.68l9.86-12.07,11.4-14a19.59,19.59,0,0,0,4.16-15.46l-2.88-17.83-2.47-15.43a19.49,19.49,0,0,1,12.3-21.35L51.37,86,68.2,79.52a19.27,19.27,0,0,0,11.3-11.3l6.44-16.84,5.57-14.63a19.52,19.52,0,0,1,21.35-12.32l15.43,2.49,17.8,2.85a19.49,19.49,0,0,0,15.46-4.16l14-11.36,12.17-9.9a19.64,19.64,0,0,1,24.65,0l12.13,9.9,14,11.36a19.43,19.43,0,0,0,15.43,4.16l17.8-2.85,15.46-2.49a19.52,19.52,0,0,1,21.35,12.32l5.57,14.6,6.44,16.87a19.36,19.36,0,0,0,11.3,11.3L348.64,86l14.6,5.58a19.51,19.51,0,0,1,12.35,21.32l-2.49,15.46-2.88,17.83a19.57,19.57,0,0,0,4.16,15.43l11.36,14,9.86,12.1A19.56,19.56,0,0,1,395.63,212.34Z"
            className="Badge__ThirdFillColor"
          />
          <path
            d="M200,394.35a14,14,0,0,1-8.79-3.13L165.09,370a25.65,25.65,0,0,0-19.86-5.31L112,370a13.54,13.54,0,0,1-2.21.18,14,14,0,0,1-13-9l-12-31.48A24.92,24.92,0,0,0,70.19,315.2l-31.45-12A14,14,0,0,1,30,288l5.34-33.26a25,25,0,0,0-5.38-19.87L8.72,208.76a14.05,14.05,0,0,1,0-17.62l21.25-26a25.25,25.25,0,0,0,5.36-19.87L30,112a14,14,0,0,1,8.75-15.24l31.48-12A24.92,24.92,0,0,0,84.75,70.14l12-31.45A14.07,14.07,0,0,1,112,29.91l33.24,5.35a25.46,25.46,0,0,0,19.91-5.37L191.21,8.65a14.38,14.38,0,0,1,17.61,0l26.1,21.24a25.25,25.25,0,0,0,19.83,5.35L288,29.91a14.09,14.09,0,0,1,15.22,8.79l12,31.47a25,25,0,0,0,14.54,14.54l31.43,12a14,14,0,0,1,8.83,15.2l-5.38,33.29A25.29,25.29,0,0,0,370,165.06l21.22,26.09a14,14,0,0,1,0,17.62L370,234.9a25,25,0,0,0-5.33,19.79L370.07,288a14,14,0,0,1-8.84,15.23l-31.42,12a25.05,25.05,0,0,0-14.55,14.56l-12,31.45A14.09,14.09,0,0,1,288,370l-33.25-5.38A25.48,25.48,0,0,0,234.92,370l-26.13,21.26A14,14,0,0,1,200,394.35Zm-50.84-38a33.47,33.47,0,0,1,21,7.41L196.27,385a6.05,6.05,0,0,0,7.47,0l26.13-21.26a33.41,33.41,0,0,1,26.17-7l33.27,5.38a6,6,0,0,0,6.48-3.78l12-31.42A33,33,0,0,1,327,307.72l31.4-12a6,6,0,0,0,3.8-6.48L356.78,256a33,33,0,0,1,7-26.1l21.26-26.13a6,6,0,0,0,0-7.51l-21.23-26.1a33.28,33.28,0,0,1-7-26.17l5.38-33.31a5.94,5.94,0,0,0-3.78-6.44L327,92.19A33,33,0,0,1,307.78,73l-12-31.45a6,6,0,0,0-6.47-3.74L256,43.16a33.2,33.2,0,0,1-26.15-7.06L203.79,14.89a6.24,6.24,0,0,0-7.54,0L170.18,36.09A33.39,33.39,0,0,1,144,43.16L110.7,37.81a6,6,0,0,0-6.47,3.74L92.24,73A32.92,32.92,0,0,1,73.05,92.19l-31.46,12a5.94,5.94,0,0,0-3.71,6.49L43.23,144a33.26,33.26,0,0,1-7,26.18l-21.25,26a6,6,0,0,0,0,7.51l21.21,26.07A33,33,0,0,1,43.23,256l-5.35,33.27a6,6,0,0,0,3.71,6.51l31.44,12A32.91,32.91,0,0,1,92.22,326.9l12,31.45a6,6,0,0,0,6.46,3.78L144,356.74A33.51,33.51,0,0,1,149.17,356.34Z"
            className="Badge__SecondFillColor"
          />
        </g>

        <g className="SUNBURST">
          <path
            d="M236.51,165.66l36.72-36.72-1.48-1.47L235,164.2C235.53,164.67,236,165.16,236.51,165.66Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M242.23,172.76,285,143.49l-1.17-1.72L241,171.05C241.45,171.61,241.85,172.18,242.23,172.76Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M285.94,190.19l-35.89,3.57c.09.68.16,1.37.22,2.07l35.88-3.57Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M246.81,181.4l47.67-20.21-.81-1.92L246,179.49C246.26,180.12,246.54,180.75,246.81,181.4Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M267.54,252.82,240.1,230.35c-.42.55-.86,1.09-1.31,1.62l27.43,22.47Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M282.71,223.66l-34-10.44c-.19.67-.38,1.34-.59,2l34,10.43Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M285.77,207.83,250.3,204c-.06.7-.12,1.39-.21,2.07l35.45,3.85Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M277,238l-31.51-16.38c-.3.63-.62,1.25-.95,1.86l31.5,16.37Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M212.12,151.89,222.83,101l-2-.42-10.71,50.92C210.77,151.59,211.45,151.74,212.12,151.89Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M228.73,159.12l28.41-43.52-1.75-1.14L227,158C227.57,158.36,228.16,158.73,228.73,159.12Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M200.43,150.62l.73,0V98.93h-2.32v51.73C200,150.65,199.94,150.62,200.43,150.62Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M207.34,151l3.89-35.89-2.07-.22-3.89,35.89C206,150.88,206.65,151,207.34,151Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M197.2,150.78l-3.61-36.23-2.07.2,3.6,36.23C195.81,150.9,196.5,150.84,197.2,150.78Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M222.72,155.64c.63.3,1.25.62,1.86,1l16.61-32-1.85-1Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M220.94,154.82l20.1-48-1.93-.8L219,154C219.66,154.27,220.31,154.54,220.94,154.82Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M216.4,153.08,227,118.59l-2-.61L214.4,152.47C215.08,152.66,215.74,152.86,216.4,153.08Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M134.49,146.54l27.81,22.78c.43-.54.88-1.08,1.33-1.6l-27.82-22.8Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M265.53,144.11,238,167.25q.69.78,1.35,1.59l27.53-23.13Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M145.44,135.17l23.17,27.57c.52-.46,1.06-.9,1.6-1.34L147,133.83Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M254.16,133.16,231.33,161c.55.43,1.09.86,1.62,1.31l22.82-27.85Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M249.53,190.47l50.59-10.72-.44-2-50.61,10.72C249.24,189.11,249.39,189.78,249.53,190.47Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M281.83,172.88l-34.14,10.86c.23.66.45,1.32.65,2l34.12-10.85Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M275.23,157.94l-31.51,17.22c.35.6.69,1.2,1,1.82l31.49-17.21Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M126.8,241.42l31.16-17c-.35-.6-.67-1.21-1-1.83l-31.17,17Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M120.19,226.48l33.9-10.78c-.22-.66-.42-1.32-.61-2l-33.92,10.78Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M256.58,264.19,233.8,237.08c-.52.46-1,.92-1.58,1.36L255,265.53Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M125,161.35l31.84,16.54c.31-.62.63-1.24,1-1.84L125.94,159.5Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M147.87,266.2l22.43-27.38c-.55-.43-1.08-.87-1.61-1.33l-22.43,27.39Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M116.08,209.17l35.8-3.56c-.08-.68-.14-1.38-.19-2.07l-35.81,3.56Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M119.31,175.71l34.24,10.5c.19-.67.4-1.33.62-2l-34.25-10.51Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M116.26,191.53l35.53,3.86c.06-.7.15-1.39.24-2.07l-35.55-3.86Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M136.5,255.25l27.14-22.81c-.46-.52-.9-1.05-1.33-1.6l-27.15,22.81Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M200.43,249.53c-.49,0-.43,0-1.59,0v51.59h2.32V249.51S200.64,249.53,200.43,249.53Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M210.32,248.64,221,298.78l2-.43-10.63-50.14C211.69,248.36,211,248.51,210.32,248.64Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M219.49,246l20,47.2,1.92-.81-20-47.21C220.78,245.41,220.14,245.69,219.49,246Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M215.12,247.48l10.7,33.65,2-.63L217.1,246.84C216.45,247.06,215.79,247.28,215.12,247.48Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M204.91,249.36l3.52,35.45,2.07-.2L207,249.16C206.29,249.24,205.6,249.31,204.91,249.36Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M194.6,249.1l-3.81,35.11,2.08.22,3.8-35.1C196,249.27,195.29,249.19,194.6,249.1Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M185.41,247l-10.36,33.77,2,.61,10.36-33.76C186.73,247.43,186.06,247.22,185.41,247Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M189.74,248.23,179.2,298.38l2,.43,10.54-50.15C191.1,248.53,190.42,248.38,189.74,248.23Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M235.43,235.57l36.32,36.32,1.48-1.47-36.34-36.33C236.42,234.59,235.93,235.09,235.43,235.57Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M249.27,210.89l50.45,10.6.43-2-50.47-10.61C249.55,209.53,249.42,210.21,249.27,210.89Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M250.44,198.84s0,.86,0,1.24,0,1.08,0,1.08h50.64v-2.32Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M246.36,219.81l47.48,19.89.8-1.92-47.49-19.9C246.9,218.53,246.64,219.18,246.36,219.81Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M180.81,245.21,161,292.51l1.92.8L182.73,246C182.08,245.77,181.44,245.49,180.81,245.21Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M228.24,241.35l29,42.36,1.72-1.17-29-42.37C229.39,240.57,228.82,241,228.24,241.35Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M224,243.87l16.95,31,1.83-1-16.95-31C225.2,243.21,224.59,243.55,224,243.87Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M242,227.7l43,28.1,1.14-1.74L243.16,226C242.8,226.54,242.43,227.13,242,227.7Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M156,179.68l-47.78-20-.81,1.92,47.76,20C155.41,181,155.68,180.31,156,179.68Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M167,164.2l-36.73-36.73-1.47,1.47,36.72,36.72C166,165.16,166.5,164.67,167,164.2Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M174.16,158.56l-29.34-42.91-1.72,1.18,29.33,42.9C173,159.33,173.58,158.94,174.16,158.56Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M160.37,171.91l-43.43-28.35-1.14,1.74,43.42,28.35C159.6,173.06,160,172.48,160.37,171.91Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M179,244.35c-.62-.31-1.24-.63-1.85-1l-16.29,31.37,1.84,1Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M191.87,151.48l-10.79-50.9-2,.43,10.78,50.9C190.5,151.75,191.18,151.61,191.87,151.48Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M182.82,154.09l-20.3-47.88-1.92.81,20.3,47.88Q181.85,154.48,182.82,154.09Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M178.39,156.11,161.1,124.47l-1.83,1,17.29,31.63C177.16,156.76,177.77,156.42,178.39,156.11Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M187.14,152.61,176.2,118.23l-2,.63,10.93,34.38C185.81,153,186.47,152.81,187.14,152.61Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M165.13,234.09,128.8,270.42l1.47,1.47,36.33-36.32C166.1,235.09,165.61,234.59,165.13,234.09Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M152.93,188.51l-50.62-10.64-.43,2,50.61,10.64C152.62,189.86,152.77,189.18,152.93,188.51Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M172.94,240.78l-28.05,43,1.75,1.14,28-43C174.09,241.56,173.51,241.18,172.94,240.78Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M159.44,226.84l-42.46,29,1.18,1.72,42.44-29C160.2,228,159.82,227.43,159.44,226.84Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M151.56,200.08c0-.38,0-1.24,0-1.24H98.92v2.32h52.66S151.56,200.4,151.56,200.08Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M152.36,208.92l-50.45,10.69.43,2L152.78,211C152.62,210.29,152.49,209.61,152.36,208.92Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
          <path
            d="M155,218.08l-47.41,20.09.82,1.92L155.75,220C155.47,219.37,155.21,218.72,155,218.08Z"
            className="Badge__FirstFillColor"
            opacity="0.1"
          />
        </g>

        <g id="_Gruppe_" data-name="<Gruppe>">
          <g id="_Gruppe_2" data-name="<Gruppe>">
            <g id="_Gruppe_3" data-name="<Gruppe>">
              <rect
                id="_Rechteck_"
                data-name="<Rechteck>"
                x="187.61"
                y="232.55"
                width="22.8"
                height="6.14"
                fill="#fcd669"
              />
            </g>
            <g id="_Gruppe_4" data-name="<Gruppe>">
              <g id="_Gruppe_5" data-name="<Gruppe>">
                <g id="_Gruppe_6" data-name="<Gruppe>">
                  <path
                    id="_Pfad_"
                    data-name="<Pfad>"
                    d="M140.92,238.7H259.08a4.54,4.54,0,0,1,4.54,4.54l-2,6.51c0,7-6.67,13.67-13.67,13.67h-94.9c-7,0-15.67-6.67-15.67-13.67l-1-6.51A4.54,4.54,0,0,1,140.92,238.7Z"
                    fill="#f6b13a"
                  />
                </g>
                <g id="_Gruppe_7" data-name="<Gruppe>">
                  <path
                    id="_Pfad_2"
                    data-name="<Pfad>"
                    d="M257.1,238.7H246.58c.49,4.49-.15,12.87-11,15.55-15.1,3.71-81.34,5.24-96.41.64h0a18.17,18.17,0,0,0,15.42,8.53h90.84a18.2,18.2,0,0,0,18.2-18.2h0A6.52,6.52,0,0,0,257.1,238.7Z"
                    fill="#f7952c"
                  />
                </g>
              </g>
              <g id="_Gruppe_8" data-name="<Gruppe>">
                <path
                  id="_Pfad_3"
                  data-name="<Pfad>"
                  d="M156,248.57h-6.76a1.63,1.63,0,0,0,0,3.25H156A1.63,1.63,0,0,0,156,248.57Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_9" data-name="<Gruppe>">
                <path
                  id="_Pfad_4"
                  data-name="<Pfad>"
                  d="M202.7,244.06h-3.9a1.63,1.63,0,0,0,0,3.25h3.9A1.63,1.63,0,0,0,202.7,244.06Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_10" data-name="<Gruppe>">
                <path
                  id="_Pfad_5"
                  data-name="<Pfad>"
                  d="M242.43,252.87h-10a1.63,1.63,0,0,0,0,3.25h10A1.63,1.63,0,0,0,242.43,252.87Z"
                  fill="#fcd669"
                />
              </g>
            </g>
            <g id="_Gruppe_11" data-name="<Gruppe>">
              <path
                id="_Pfad_6"
                data-name="<Pfad>"
                d="M255.71,204.82H144.29a6.31,6.31,0,0,1-6.29-6.29h0a6.31,6.31,0,0,1,6.29-6.29H255.71a6.31,6.31,0,0,1,6.29,6.29h0A6.31,6.31,0,0,1,255.71,204.82Z"
                fill="#bc5f46"
              />
            </g>
            <g id="_Gruppe_12" data-name="<Gruppe>">
              <rect
                id="_Pfad_7"
                data-name="<Pfad>"
                x="134.34"
                y="208.55"
                width="131.33"
                height="17.07"
                rx="8.42"
                ry="8.42"
                fill="#f05755"
              />
            </g>
            <g id="_Gruppe_13" data-name="<Gruppe>">
              <path
                id="_Pfad_8"
                data-name="<Pfad>"
                d="M257.24,208.55H230.75a12.12,12.12,0,0,1-2.64.65L223.27,218h0a2.16,2.16,0,0,1-.65,4.21c-31.25.49-87-1.14-87.35-1.15a8.43,8.43,0,0,0,7.49,4.59H257.24a6.85,6.85,0,0,0,.79,0h.11c.22,0,.44-.06.65-.11l.24,0,.53-.14.35-.11.07,0a8.44,8.44,0,0,0,5.68-8V217A8.44,8.44,0,0,0,257.24,208.55Z"
                fill="#e24647"
              />
            </g>
            <g id="_Gruppe_14" data-name="<Gruppe>">
              <path
                id="_Pfad_9"
                data-name="<Pfad>"
                d="M262,198.53a6.31,6.31,0,0,0-6.29-6.29H248.2c1.49,1.43,3.07,3.66,2.38,6.29-1.13,4.28-90.64,4.49-112.51.88a6.3,6.3,0,0,0,6.22,5.41H255.71A6.31,6.31,0,0,0,262,198.53Z"
                fill="#aa3c26"
              />
            </g>
            <g id="_Gruppe_15" data-name="<Gruppe>">
              <g id="_Gruppe_16" data-name="<Gruppe>">
                <g id="_Gruppe_17" data-name="<Gruppe>">
                  <g id="_Gruppe_18" data-name="<Gruppe>">
                    <path
                      id="_Pfad_10"
                      data-name="<Pfad>"
                      d="M195.5,238.7H143.58a5.59,5.59,0,0,1-5.57-5.58h0a5.59,5.59,0,0,1,5.57-5.57H195.5a5.59,5.59,0,0,1,5.58,5.57h0A5.6,5.6,0,0,1,195.5,238.7Z"
                      fill="#bc5f46"
                    />
                  </g>
                </g>
                <g id="_Gruppe_19" data-name="<Gruppe>">
                  <path
                    id="_Pfad_11"
                    data-name="<Pfad>"
                    d="M195.5,227.55h-1.3c.52,1.66.45,4.76-6,6.78-9.15,2.87-43.37,1.36-49.4,0a5.59,5.59,0,0,0-.68-.12,5.59,5.59,0,0,0,5.46,4.49H195.5a5.6,5.6,0,0,0,5.58-5.58h0A5.59,5.59,0,0,0,195.5,227.55Z"
                    fill="#aa3c26"
                  />
                </g>
                <g id="_Gruppe_20" data-name="<Gruppe>">
                  <g id="_Gruppe_21" data-name="<Gruppe>">
                    <path
                      id="_Zusammengesetzter_Pfad_"
                      data-name="<Zusammengesetzter Pfad>"
                      d="M195.5,240.13H143.58a7,7,0,0,1,0-14H195.5a7,7,0,1,1,0,14ZM143.58,229a4.14,4.14,0,0,0,0,8.28H195.5a4.14,4.14,0,0,0,0-8.28Z"
                      fill="#84171a"
                    />
                  </g>
                </g>
              </g>
              <g id="_Gruppe_22" data-name="<Gruppe>">
                <g id="_Gruppe_23" data-name="<Gruppe>">
                  <g id="_Gruppe_24" data-name="<Gruppe>">
                    <path
                      id="_Pfad_12"
                      data-name="<Pfad>"
                      d="M256.42,238.7H204.5a5.6,5.6,0,0,1-5.58-5.58h0a5.59,5.59,0,0,1,5.58-5.57h51.92a5.59,5.59,0,0,1,5.57,5.57h0A5.59,5.59,0,0,1,256.42,238.7Z"
                      fill="#bc5f46"
                    />
                  </g>
                </g>
                <g id="_Gruppe_25" data-name="<Gruppe>">
                  <path
                    id="_Pfad_13"
                    data-name="<Pfad>"
                    d="M256.42,227.55h-1.3c.51,1.66.44,4.76-6,6.78-9.15,2.87-43.38,1.36-49.41,0a5.59,5.59,0,0,0-.68-.12,5.61,5.61,0,0,0,5.47,4.49h51.92a5.59,5.59,0,0,0,5.57-5.58h0A5.59,5.59,0,0,0,256.42,227.55Z"
                    fill="#aa3c26"
                  />
                </g>
              </g>
            </g>
            <g id="_Gruppe_26" data-name="<Gruppe>">
              <path
                id="_Pfad_14"
                data-name="<Pfad>"
                d="M140.42,192.5a2.75,2.75,0,0,1,3-2.44H256.6a2.49,2.49,0,1,1,0,4.88s-14.09,1.12-16.75,3.3-2.78,3.66-7.13,2.18-5.32-4-10.28-3-4,2.37-10.87,1.28-15-4-22-1.18-5.44,6.92-13.42,5-10.28-6.82-15.72-5.74-11.24,1.29-14,.3a19.76,19.76,0,0,1-4.83-2.71A2.34,2.34,0,0,1,140.42,192.5Z"
                fill="#9db73e"
              />
            </g>
            <g id="_Gruppe_27" data-name="<Gruppe>">
              <path
                id="_Pfad_15"
                data-name="<Pfad>"
                d="M256.6,194.94a2.49,2.49,0,1,0,0-4.88H244.53c-1.08,1.9-3.53,5.14-7.77,5.34-6,.27-11.63-2.32-21,0-3.94,1-6.76,1.79-9.1,2.37,1.69.36,3.34.71,4.94,1,6.89,1.09,5.92-.29,10.87-1.28s5.93,1.48,10.28,3,4.47,0,7.13-2.18S256.6,194.94,256.6,194.94Z"
                fill="#8da43c"
              />
            </g>
            <g id="_Gruppe_28" data-name="<Gruppe>">
              <path
                id="_Zusammengesetzter_Pfad_2"
                data-name="<Zusammengesetzter Pfad>"
                d="M179.58,204.5a16.73,16.73,0,0,1-3.76-.51,28,28,0,0,1-8.53-3.74c-2.49-1.49-4.13-2.48-6.57-2-4.93,1-11.41,1.44-14.79.24a20.93,20.93,0,0,1-5.17-2.89A3.74,3.74,0,0,1,139,192.5a4.18,4.18,0,0,1,4.42-3.87H256.6a3.91,3.91,0,1,1,.06,7.75c-5.66.45-14.31,1.67-15.9,3-.48.39-.87.76-1.25,1.12-1.82,1.72-3.15,2.7-7.25,1.3a20.34,20.34,0,0,1-3.77-1.77c-1.87-1.06-3-1.7-5.76-1.15a19.68,19.68,0,0,0-3.21.93c-2.07.77-3.38,1.13-8.18.37-1.58-.25-3.18-.59-4.87-.94-5.57-1.18-11.33-2.4-16.36-.34a15.4,15.4,0,0,0-4.85,3.14C183.58,203.49,182.18,204.5,179.58,204.5Zm-17.65-9.23c2.63,0,4.69,1.23,6.83,2.52a25.47,25.47,0,0,0,7.72,3.41c4.23,1,5.06.26,6.88-1.34a18.11,18.11,0,0,1,5.66-3.64c5.85-2.39,12.32-1,18,.18,1.65.35,3.22.68,4.73.92,4.28.67,5.15.35,6.74-.23a22.07,22.07,0,0,1,3.63-1.05,9.66,9.66,0,0,1,7.74,1.46,18.31,18.31,0,0,0,3.28,1.56c2.68.91,3,.64,4.36-.68.39-.37.84-.79,1.4-1.25,2.86-2.34,15.12-3.42,17.55-3.61h.11c.91,0,1.55-.53,1.55-1s-.64-1-1.55-1H143.4c-.91,0-1.55.54-1.55,1a1,1,0,0,0,.5.72l.1.07a18.23,18.23,0,0,0,4.44,2.51c2.44.87,7.89.72,13.26-.35A8.74,8.74,0,0,1,161.93,195.27Z"
                fill="#84171a"
              />
            </g>
            <g id="_Gruppe_29" data-name="<Gruppe>">
              <path
                id="_Zusammengesetzter_Pfad_3"
                data-name="<Zusammengesetzter Pfad>"
                d="M245.42,264.86H154.58a19.66,19.66,0,0,1-19.64-19.64,8,8,0,0,1,8-8H257.09a8,8,0,0,1,8,8A19.66,19.66,0,0,1,245.42,264.86ZM142.91,240.13a5.11,5.11,0,0,0-5.1,5.09A16.79,16.79,0,0,0,154.58,262h90.84a16.79,16.79,0,0,0,16.77-16.77,5.11,5.11,0,0,0-5.1-5.09Z"
                fill="#84171a"
              />
            </g>
            <g id="_Gruppe_30" data-name="<Gruppe>">
              <g id="_Gruppe_31" data-name="<Gruppe>">
                <g id="_Gruppe_32" data-name="<Gruppe>">
                  <path
                    id="_Pfad_16"
                    data-name="<Pfad>"
                    d="M142.07,192.24a6.3,6.3,0,0,1-6.11-7.32c4.16-27.28,31.25-48.34,64-48.34s59.88,21.06,64,48.34a6.3,6.3,0,0,1-6.11,7.32Z"
                    fill="#f6b13a"
                  />
                </g>
                <g id="_Gruppe_33" data-name="<Gruppe>">
                  <path
                    id="_Pfad_17"
                    data-name="<Pfad>"
                    d="M264,184.92c-3.46-22.69-22.77-41.07-48-46.62,0,0,23.59,14.76,16.57,38-6.17,20.39-79,11.06-96.58,8.48l0,.18a6.3,6.3,0,0,0,6.11,7.32H257.93A6.3,6.3,0,0,0,264,184.92Z"
                    fill="#f7952c"
                  />
                </g>
              </g>
              <g id="_Gruppe_34" data-name="<Gruppe>">
                <path
                  id="_Pfad_18"
                  data-name="<Pfad>"
                  d="M161.53,161.56h-4.71a1.63,1.63,0,0,0,0,3.25h4.71A1.63,1.63,0,0,0,161.53,161.56Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_35" data-name="<Gruppe>">
                <path
                  id="_Pfad_19"
                  data-name="<Pfad>"
                  d="M187.13,151.12h-9.42a1.63,1.63,0,0,0,0,3.25h9.42A1.63,1.63,0,0,0,187.13,151.12Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_36" data-name="<Gruppe>">
                <path
                  id="_Pfad_20"
                  data-name="<Pfad>"
                  d="M207.61,161.77h-4.1a1.63,1.63,0,0,0,0,3.25h4.1A1.63,1.63,0,0,0,207.61,161.77Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_37" data-name="<Gruppe>">
                <path
                  id="_Pfad_21"
                  data-name="<Pfad>"
                  d="M163.58,179h-5.73a1.63,1.63,0,0,0,0,3.25h5.73A1.63,1.63,0,0,0,163.58,179Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_38" data-name="<Gruppe>">
                <path
                  id="_Pfad_22"
                  data-name="<Pfad>"
                  d="M215.6,175.08h-2a1.63,1.63,0,1,0,0,3.25h2a1.63,1.63,0,0,0,0-3.25Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_39" data-name="<Gruppe>">
                <path
                  id="_Pfad_23"
                  data-name="<Pfad>"
                  d="M236.49,153.58H225.84a1.63,1.63,0,0,0,0,3.25h10.65A1.63,1.63,0,0,0,236.49,153.58Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_40" data-name="<Gruppe>">
                <path
                  id="_Pfad_24"
                  data-name="<Pfad>"
                  d="M247.75,181.43h-5.12a1.63,1.63,0,0,0,0,3.25h5.12A1.63,1.63,0,0,0,247.75,181.43Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_41" data-name="<Gruppe>">
                <path
                  id="_Pfad_25"
                  data-name="<Pfad>"
                  d="M184.88,173.44h-2.46a1.63,1.63,0,1,0,0,3.25h2.46a1.63,1.63,0,0,0,0-3.25Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_42" data-name="<Gruppe>">
                <path
                  id="_Pfad_26"
                  data-name="<Pfad>"
                  d="M208.43,142.31h-3.69a1.63,1.63,0,0,0,0,3.25h3.69A1.63,1.63,0,0,0,208.43,142.31Z"
                  fill="#fcd669"
                />
              </g>
              <g id="_Gruppe_43" data-name="<Gruppe>">
                <path
                  id="_Zusammengesetzter_Pfad_4"
                  data-name="<Zusammengesetzter Pfad>"
                  d="M257.93,193.67H142.07a7.56,7.56,0,0,1-5.72-2.65,7.87,7.87,0,0,1-1.81-6.32c2.08-13.64,9.84-26.19,21.83-35.32s27.55-14.23,43.63-14.23,31.57,5,43.63,14.23,19.75,21.68,21.83,35.32a7.87,7.87,0,0,1-1.81,6.32A7.56,7.56,0,0,1,257.93,193.67ZM200,138c-31.6,0-58.53,20.26-62.62,47.12a5,5,0,0,0,1.14,4,4.7,4.7,0,0,0,3.55,1.65H257.93a4.69,4.69,0,0,0,3.55-1.65,5,5,0,0,0,1.14-4C258.53,158.27,231.6,138,200,138Z"
                  fill="#84171a"
                />
              </g>
            </g>
            <g id="_Gruppe_44" data-name="<Gruppe>">
              <path
                id="_Zusammengesetzter_Pfad_5"
                data-name="<Zusammengesetzter Pfad>"
                d="M255.71,206.25H144.29a7.73,7.73,0,0,1,0-15.45H255.71a7.73,7.73,0,0,1,0,15.45ZM144.29,193.67a4.86,4.86,0,1,0,0,9.71H255.71a4.86,4.86,0,1,0,0-9.71Z"
                fill="#84171a"
              />
            </g>
            <g id="_Gruppe_45" data-name="<Gruppe>">
              <path
                id="_Zusammengesetzter_Pfad_6"
                data-name="<Zusammengesetzter Pfad>"
                d="M257.24,227.06H142.76a9.87,9.87,0,0,1-9.86-9.86V217a9.86,9.86,0,0,1,9.86-9.85H257.24A9.86,9.86,0,0,1,267.1,217v.23A9.87,9.87,0,0,1,257.24,227.06ZM142.76,210a7,7,0,0,0-7,7v.23a7,7,0,0,0,7,7H257.24a7,7,0,0,0,7-7V217a7,7,0,0,0-7-7Z"
                fill="#84171a"
              />
            </g>
            <g id="_Gruppe_46" data-name="<Gruppe>">
              <path
                id="_Pfad_27"
                data-name="<Pfad>"
                d="M259.43,227.63a3.2,3.2,0,0,0-2.86-2H143.44a3,3,0,0,0-2.88,2c-.63,2,3,3.92,5,3.92,0,0,10.51,1.12,13.17,3.78s4.76,5.7,9.11,3.89,4.79-5.82,9.75-4.61,4,2.9,10.87,1.57,15-5,22-1.45,5.44,8.46,13.42,6.16,10.28-8.34,15.72-7,11.24,1.57,14,.37a19.2,19.2,0,0,0,4.83-3.32A3,3,0,0,0,259.43,227.63Z"
                fill="#9db73e"
              />
            </g>
            <g id="_Gruppe_47" data-name="<Gruppe>">
              <path
                id="_Pfad_28"
                data-name="<Pfad>"
                d="M256.57,225.62H244c-1.75,2.44-6,5.77-15.83,5.68-15.57-.13-24.85-3.92-36.46,2.27a52,52,0,0,1-7,3.13,23,23,0,0,0,3.73-.48c6.89-1.33,15-5,22-1.45s5.44,8.46,13.42,6.16,10.28-8.34,15.72-7,11.24,1.57,14,.37a19.2,19.2,0,0,0,4.83-3.32,3,3,0,0,0,1-3.34A3.2,3.2,0,0,0,256.57,225.62Z"
                fill="#8da43c"
              />
            </g>
            <g id="_Gruppe_48" data-name="<Gruppe>">
              <path
                id="_Zusammengesetzter_Pfad_7"
                data-name="<Zusammengesetzter Pfad>"
                d="M220.39,243c-2.64,0-4.06-1.26-5.75-3.08a15.43,15.43,0,0,0-4.85-3.83c-4.95-2.48-10.67-1-16.2.42-1.69.44-3.29.85-4.88,1.16-4.87.94-6.27.46-8.32-.47a16.77,16.77,0,0,0-3.17-1.12c-2.31-.56-3.16.22-4.69,1.64a13.62,13.62,0,0,1-4.17,2.9c-4.74,2-7.41-.81-9.77-3.27l-.91-.93c-1.66-1.66-8.35-2.94-12.23-3.36a8.18,8.18,0,0,1-5.67-2.82,3.28,3.28,0,0,1-.59-2.95,4.44,4.44,0,0,1,4.25-3.06H256.57a4.6,4.6,0,0,1,4.22,3h0a4.4,4.4,0,0,1-1.45,4.86,20.23,20.23,0,0,1-5.18,3.54c-3,1.31-8.87,1.2-14.93-.28-2.24-.55-3.74.45-6.41,2.41a26,26,0,0,1-8.57,4.58A14,14,0,0,1,220.39,243ZM203.7,231.85a16.16,16.16,0,0,1,7.38,1.64,18.17,18.17,0,0,1,5.66,4.44c1.85,2,2.61,2.81,6.72,1.63a23.7,23.7,0,0,0,7.67-4.14c2.64-1.95,5.13-3.78,8.78-2.89,5.23,1.28,10.75,1.47,13.11.44a18.07,18.07,0,0,0,4.43-3.05l.09-.09a1.55,1.55,0,0,0,.52-1.76h0a1.78,1.78,0,0,0-1.49-1H143.44a1.55,1.55,0,0,0-1.51,1c0,.11.07.28.16.41a5.39,5.39,0,0,0,3.44,1.66h.15c1.13.12,11.1,1.26,14,4.19.32.32.64.65.95,1,2.41,2.51,3.8,3.77,6.6,2.6a10.9,10.9,0,0,0,3.32-2.35c1.64-1.53,3.51-3.25,7.32-2.32a19.2,19.2,0,0,1,3.67,1.29c1.59.72,2.38,1.07,6.59.26,1.51-.29,3.07-.69,4.72-1.12A44.32,44.32,0,0,1,203.7,231.85Z"
                fill="#84171a"
              />
            </g>
            <g id="_Gruppe_49" data-name="<Gruppe>">
              <path
                id="_Pfad_29"
                data-name="<Pfad>"
                d="M259.33,204.82H141.56a1.87,1.87,0,1,0,0,3.73h45.07s26.42,6.7,38.81,10a8.29,8.29,0,0,0,5.55-.46l21.16-9.54h7.18a1.87,1.87,0,0,0,0-3.73Z"
                fill="#fcd669"
              />
            </g>
            <g id="_Gruppe_50" data-name="<Gruppe>">
              <path
                id="_Pfad_30"
                data-name="<Pfad>"
                d="M259.33,204.82h-22.2c-.7,3.17-3.09,9.63-11.09,10.26-10.65.84-22.87-2.31-22.87-2.31h0c7.75,2,16.52,4.25,22.27,5.78a8.29,8.29,0,0,0,5.55-.46l21.16-9.54h7.18a1.87,1.87,0,0,0,0-3.73Z"
                fill="#fbc231"
              />
            </g>
            <g id="_Gruppe_51" data-name="<Gruppe>">
              <path
                id="_Zusammengesetzter_Pfad_8"
                data-name="<Zusammengesetzter Pfad>"
                d="M227.57,220.26a9.51,9.51,0,0,1-2.49-.33c-11.73-3.11-36.32-9.36-38.63-9.94H141.56a3.31,3.31,0,1,1,0-6.61H259.33a3.31,3.31,0,0,1,0,6.61h-6.87l-20.88,9.41A9.8,9.8,0,0,1,227.57,220.26Zm-86-14a.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43h45.25l.17,0c.27.07,26.57,6.74,38.83,10a6.91,6.91,0,0,0,4.59-.38l21.44-9.66h7.49a.43.43,0,0,0,.43-.43.44.44,0,0,0-.43-.44Z"
                fill="#84171a"
              />
            </g>
          </g>
        </g>

      </g>

      {/* ------------------------------------------ */}

      <g className="TEXT">

        <text
          x=""
          y=""
          dy=".7ex"
          textAnchor="middle"
          fontFamily="Miriam Libre"
          fontSize="1.9em"
          letterSpacing="0.05em"
          className="Badge__FirstFillColor"
        >
          <textPath xlinkHref="#BurgerBadge__TopCircle" startOffset="50%">
            + &nbsp; {line1.toUpperCase()} {line2.toUpperCase()} &nbsp; +
          </textPath>
        </text>

        <text
          x=""
          y=""
          dy=".79ex"
          textAnchor="middle"
          fontFamily="Miriam Libre"
          fontSize="1.9em"
          letterSpacing="0.05em"
          className="Badge__FirstFillColor"
        >
          <textPath xlinkHref="#BurgerBadge__BottomCircle" startOffset="50%">
            {line3.toUpperCase()} {line4.toUpperCase()}
          </textPath>
        </text>

      </g>

      {/* ------------------------------------------ */}

    </svg>
  );
}

export default Badge;
